module.exports = __webpack_public_path__ + "assets/svg/logo_acoucou_white.svg";